import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import RootSiblings from 'react-native-root-siblings';
import { isWeb } from '@/common/device-info';

export interface FixedToastProps {
    text: string | (() => React.ReactNode);
    duration?: number;
    zIndex?: number;
    numberOfLines?: number;
    // 没有用，兼容老的
    useModel?: boolean;
}

/**
 * 半屏吸底的简版Toast组件
 * zIndex  Toast 3000 > Dialog 2000 > Popup 1000
 */
export function FixedToast(props: FixedToastProps) {
    const { height } = useDraggableHeight({ debounceTime: 50 });
    const { zIndex = 3000, numberOfLines = 3, text } = props;
    const [layoutHeight, setLayoutHeight] = useState(0); // 默认43是设计稿的尺寸

    return (
        <View
            className={'Toast'}
            style={[
                {
                    width: '100%',
                    position: 'absolute',
                    zIndex,
                    top: isWeb ? '50vh' : height / 2,
                    alignItems: 'center',
                },
            ]}>
            <View
                style={{
                    maxWidth: 376,
                    backgroundColor: 'rgba(44, 44, 44, 0.72)',
                    borderRadius: 8,
                    paddingTop: 12,
                    paddingBottom: 12,
                    paddingLeft: 16,
                    paddingRight: 16,
                    transform: [{ translateY: -layoutHeight / 2 }],
                    opacity: layoutHeight ? 1 : 0,
                }}
                onLayout={event => setLayoutHeight(event.nativeEvent.layout.height)}>
                {typeof text === 'string' ? (
                    <Text
                        style={{"fontSize":"3.8647342995169085rem","lineHeight":"4.516908212560387rem","color":"#fff"}}
                        numberOfLines={numberOfLines}>
                        {text}
                    </Text>
                ) : (
                    text()
                )}
            </View>
        </View>
    );
}

// 增加一个策略，相同的toast只展示一个，避免叠加
let currentMsg;

FixedToast.show = (options: (FixedToastProps & { onClose?: () => void }) | string) => {
    let props = options as FixedToastProps & { onClose?: () => void };
    if (typeof options === 'string') {
        props = { text: options };
    }

    if (props.text === currentMsg) {
        return;
    } else {
        currentMsg = props.text;
    }

    const sibling = new RootSiblings(<FixedToast {...props} />);
    const { duration = 3000 } = props;

    setTimeout(() => {
        sibling.destroy();
        currentMsg = '';
        props.onClose?.();
    }, duration);

    return {
        close() {
            sibling.destroy();
        },
    };
};
